/** .........
 * Localizes dates.
 *
 * If your date has a `T`, replace `T` with an empty space before passing it into this function.
 *
 * @example
 * ```tsx
 * const readableDate = createdDt.replace('T', ' '); // `createdDt` is a timestamp
 * const localDate = new Date(readableDate);
 *
 * const localizedDate = localizeDate({date: 'localeDate', appLanguage})
 * ```
 */

export function localizeDate({ date, appLanguage }: { appLanguage: string; date: Date }) {
  return new Intl.DateTimeFormat(appLanguage, { calendar: 'gregory' }).format(date);
}

export function localizeYear({ year, appLanguage }: { appLanguage: string; year: number }) {
  return new Intl.DateTimeFormat(appLanguage, { calendar: 'gregory', year: 'numeric' }).format(new Date(year, 0, 1));
}
